module.exports = __webpack_public_path__ + "static/img/thridparty.4bd50c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thridparty.png
// module id = UhhF
// module chunks = 29